import React from 'react'
import makeStyles from '@material-ui/core/styles/makeStyles'
import styles from '../../styles'
import { Backdrop, ButtonBase, Fade, Modal, Paper, Theme } from '@material-ui/core'
import classNames from 'classnames'
import Icon from '../../components/icon/Icon'
import iconsEnum from '../../enums/iconsEnum'
import { FormattedMessage, IntlShape, useIntl } from 'react-intl'
import IconNumberComponent from './IconNumberComponent'
import { YfManagerModel } from '../../types/yfPopin/yfManagerModel'
import { connect, useDispatch, useSelector } from 'react-redux'
import { RootState } from '../reducers'
import { displayModal, hideModal } from '../reducers/modal/actions'
import { modalTypes } from '../../enums/modalTypeEnum'
import { isModalVisible } from '../reducers/modal/selector'
import links from '../../enums/linksEnum'
import { useHistory } from 'react-router'
import { defaultYfDisplay, typeYfDisplay } from '../../enums/yfManagerEnums'
import YFDisplay from './YFDisplay'

const useStyle = makeStyles<Theme, { youfirstManager: YfManagerModel }>((theme) => ({
        ...styles(theme),
        modal: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
            height: '100%'
        },
        popInContainer: {
            height: '100%'
        },
        yfTitleDiv: {
            textAlign: 'left',
            height: '6%',
            width: '100%',
            backgroundColor: theme.palette.blue['10'],
            display: 'flex',
            alignItems: 'center'
        },
        subTitlePopIn: {
            marginLeft: '1%'
        },
        spanDiv: {
            verticalAlign: 'middle',
            width: '100%',
            marginLeft: '6%'
        },
        buttonIcon: {
            position: 'fixed',
            zIndex: 1121,
            padding: 8,
            backgroundColor: theme.palette.blue.main,
            bottom: 24,
            right: 40,
            borderRadius: 40,
            fill: 'white'
        },
        managerImg: {
            height: 48,
            width: 48
        },
        paper: {
            width: '100%',
            height: '100%'
        },
        buttonPopIn: {
            width: 48,
            height: 48,
            borderRadius: 32,
            backgroundColor: theme.palette.dynamic.main,
            bottom: '5vw',
            right: '5vw',
            position: 'fixed',
            '&:hover': {
                backgroundColor: theme.palette.blue['50'],
                '& svg': {
                    fill: theme.palette.blue.main
                }
            }
        },
        iconPopIn: {
            fill: 'white'
        },
        titleDiv: {
            width: '100%',
            marginTop: '5%',
            marginLeft: '6%',
            textAlign: 'left'
        },
        subTitleDiv: {
            width: '46%'
        },
        availabilityDiv: {
            marginTop: '10%'
        },
        yfManagerButtons: {
            flexDirection: 'row',
            justifyContent: 'center',
            width: '100%',
            minHeight: 40,
            height: '7%',
            '& button': {
                width: '50%',
                height: '100%'
            }
        },
        blueButton: {
            backgroundColor: theme.palette.blue.main
        },
        greenButton: {
            backgroundColor: theme.palette.dynamic.main
        },
        numberDivPopIn: {
            margin: '3% 5%'
        },
        listNumberPopIn: {
            marginTop: '5%'
        },
        coverDiv: {
            backgroundColor: theme.palette.blue['10'],
            height: '35%',
            display: 'flex',
            boxSizing: 'border-box',
            backgroundImage: props => `url('${props.youfirstManager.picture === defaultYfDisplay ? 'img/yfm_img/defaultYFM.png' : props.youfirstManager.picture}')`,
            backgroundRepeat: 'no-repeat',
            backgroundSize: 190,
            backgroundPosition: 'right bottom'
        },
        handleBreakLine: {
            whiteSpace: 'pre-line'
        },
        availabilityTextStyle : {
            fontSize: '9.5px',
        }
    }
))

interface AcceptingProps {
    subTitle: string,
    managerTitle: string,
    urgenceLabel: string,
    youfirstManager: YfManagerModel,
}

interface Store {
    displayModal: (modalType: string, content?: any) => void,
}

type YFMobilePopInProps = AcceptingProps & Store

const YFMobilePopIn: React.FC<YFMobilePopInProps> = (
    {
        subTitle,
        managerTitle,
        urgenceLabel,
        youfirstManager,
        displayModal
    }
) => {
    const classes = useStyle({ youfirstManager })
    const intl: IntlShape = useIntl()
    const history = useHistory()
    const is_open = useSelector((state: RootState) => isModalVisible(state, modalTypes.youFirstManager))
    const dispatch = useDispatch()

    const titlePopIn = classNames(
        classes.text8,
        classes.colorBlue
    )
    const subTitlePopIn = classNames(
        classes.text9,
        classes.colorBlue,
        classes.subTitlePopIn
    )
    const titleCoverPopIn = classNames(
        classes.colorBlue,
        classes.title6
    )
    const availabilityTextPopIn = classNames(
        classes.colorBlue,
        classes.text3,
        classes.availabilityTextStyle,
        classes.handleBreakLine
    )
    const yfManagerButtons = classNames(
        classes.yfManagerButtons
    )
    const yfTextButton = classNames(
        classes.colorWhite,
        classes.text4,
        classes.handleBreakLine
    )
    const yfTitleNumber = classNames(
        classes.text3,
        classes.heavy,
        classes.colorBlue
    )

    const handleOnClickPopIn = () => {
        if (is_open) {
            dispatch(
                hideModal(modalTypes.youFirstManager)
            )
        } else {
            dispatch(
                displayModal(modalTypes.youFirstManager)
            )
        }
    }

    const handleClosePopIn = () => {
        dispatch(
            hideModal(modalTypes.youFirstManager)
        )
    }

    const goToDemandes = () => {
        history.push(links.requests)
    }

    const yfData = youfirstManager.data

    return (
        <>
            <ButtonBase onClick={handleOnClickPopIn} className={classes.buttonIcon}>
                <YFDisplay type={typeYfDisplay.POPIN}/>
            </ButtonBase>

            <Modal
                disableEnforceFocus
                className={classes.modal}
                open={is_open}
                onClose={handleClosePopIn}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                    timeout: 500
                }}
            >
                <Fade in={is_open}>
                    <Paper className={classes.paper}>
                        <div className={classes.popInContainer}>
                            <div className={classes.yfTitleDiv}>
                                <div className={classes.spanDiv}>
									<span className={titlePopIn}>
										{yfData.nom}
									</span>

                                    <span className={subTitlePopIn}>
										{subTitle}
									</span>
                                </div>
                            </div>
                            <div className={classes.coverDiv}>
                                <div className={classes.titleDiv}>
                                    <span className={titleCoverPopIn}>
											{managerTitle}
										</span>
                                    <div className={classes.subTitleDiv}>

                                        <div className={classes.availabilityDiv}>
											<span className={availabilityTextPopIn}>
									            {yfData.horaires}
											</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className={yfManagerButtons}>
                                <ButtonBase className={classes.blueButton}>
							<span
                                className={yfTextButton}
                            >
                                {yfData.contact}
							</span>
                                </ButtonBase>
                                <ButtonBase
                                    className={classes.greenButton}
                                    onClick={() => displayModal(modalTypes.demandes, { callback: goToDemandes })}
                                >
							<span
                                className={yfTextButton}
                            >
							   <FormattedMessage
                                   id="you_first_manager.sendMsg"
                                   defaultMessage="Envoyer un message"
                                   description="YF contact text"
                               />
							</span>
                                </ButtonBase>
                            </div>
                            <div className={classes.numberDivPopIn}>
                                <div>
									<span className={yfTitleNumber}>
                                        {urgenceLabel}
									</span>
                                </div>
                                <div className={classes.listNumberPopIn}>
                                    {yfData.urgenceTech &&  <IconNumberComponent
		                                iconName={iconsEnum.Hotline}
		                                title={intl.formatMessage({
                                            id: 'you_first_manager.technical',
                                            defaultMessage: 'Urgence technique',
                                            description: 'Technical number'
		                                })}
		                                number={yfData.urgenceTech}
	                                />}
                                    {yfData.chauffagiste && <IconNumberComponent
		                                iconName={iconsEnum.Heater}
		                                title={intl.formatMessage({
                                            id: 'you_first_manager.heating',
                                            defaultMessage: 'Chauffagiste',
                                            description: 'Heating engineer number'
		                                })}
		                                number={yfData.chauffagiste}
	                                />}
                                    <IconNumberComponent
                                        iconName={iconsEnum.Faq2}
                                         title={intl.formatMessage({
                                             id: 'you_first_manager.emergency',
                                             defaultMessage: 'N° d’urgence',
                                             description: 'Emergency number'
                                         })}
                                         number={yfData.urgence} />
                                    {yfData.ascensoriste && <IconNumberComponent
		                                iconName={iconsEnum.Elevator}
		                                title={intl.formatMessage({
                                            id: 'you_first_manager.elevator',
                                            defaultMessage: 'Ascenseur',
                                            description: 'Elevator number'
		                                })}
		                                number={yfData.ascensoriste} />}
                                    {yfData.parking && <IconNumberComponent
		                                iconName={iconsEnum.Garage2}
		                                title={intl.formatMessage({
                                            id: 'you_first_manager.parking',
                                            defaultMessage: 'Portes de parking',
                                            description: 'Parking number'
		                                })}
		                                number={yfData.parking} />}
                                </div>
                                <ButtonBase className={classes.buttonPopIn} onClick={handleClosePopIn}>
                                    <Icon icon={iconsEnum.Cross} size={20} className={classes.iconPopIn} />
                                </ButtonBase>
                            </div>
                        </div>
                    </Paper>
                </Fade>
            </Modal>
        </>
    )
}

const mapDispatchToProps = {
    displayModal
}

export default connect(null, mapDispatchToProps)(YFMobilePopIn)
